(() => {
  'use strict';
  const KEY = 'meddey_wishlist';
  const labels = window.meddeyUIStrings?.wishlist || {};
  const t = (key, fallback) => labels[key] || fallback;
  const root = window.themeVariables?.routes?.rootUrl || '/';
  const addUrl = (window.themeVariables?.routes?.cartAddUrl || '/cart/add') + '.js';
  const cache = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let dialog, list, foot, allBox, addBtn, buyBtn, note, countChip, previousFocus, generation = 0;

  const read = () => { try { const value = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(value) ? [...new Set(value.filter(x => typeof x === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(x)))] : []; } catch { return []; } };
  const node = (tag, text) => { const n = document.createElement(tag); if (text) n.textContent = text; return n; };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.themeVariables?.settings?.cartCurrency || 'INR' }).format(cents / 100);

  async function productData(handle) {
    const saved = cache.get(handle); if (saved && Date.now() - saved.time < 60000) return saved.value;
    const value = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } }).then(r => { if (!r.ok) throw new Error('unavailable'); return r.json(); });
    cache.set(handle, { time: Date.now(), value });
    try { return await value; } catch (e) { cache.delete(handle); throw e; }
  }

  /* ---------- one-time styles ---------- */
  const style = document.createElement('style');
  style.textContent = [
    '#meddey-wishlist{padding:0;border:0;border-radius:16px;background:#fff;color:#263445;width:min(660px,calc(100vw - 24px));max-height:min(86dvh,760px);overflow:hidden;box-shadow:0 24px 60px rgba(16,32,56,.24)}',
    '#meddey-wishlist[open]{display:flex;flex-direction:column}',
    '#meddey-wishlist::backdrop{background:rgba(16,32,56,.55)}',
    '.mwl__head{position:sticky;top:0;z-index:2;display:flex;align-items:center;gap:12px;padding:16px 18px;border-bottom:1px solid #e6eef7;background:#fff}',
    '.mwl__head h2{margin:0;font-size:18px;line-height:1.3;flex:1;min-width:0}',
    '.mwl__chip{display:inline-block;margin-inline-start:8px;padding:2px 9px;border-radius:999px;background:#eef4fb;color:#3a5a82;font-size:12px;font-weight:600;vertical-align:middle}',
    '.mwl__close{flex:none;width:40px;height:40px;min-width:40px;display:flex;align-items:center;justify-content:center;border:1px solid #dce7f2;border-radius:50%;background:#fff;color:#263445;font-size:22px;line-height:1;cursor:pointer;padding:0}',
    '.mwl__close:hover{background:#f4f8fc}',
    /* Lenis smooth-scroll swallows wheel events unless the container opts out -
       data-lenis-prevent is set on this element in build(). */
    '.mwl__body{flex:1 1 auto;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;padding:4px 18px;scrollbar-width:thin;scrollbar-color:#c9d6e4 transparent}',
    '.mwl__body::-webkit-scrollbar{width:8px}',
    '.mwl__body::-webkit-scrollbar-track{background:transparent}',
    '.mwl__body::-webkit-scrollbar-thumb{background:#c9d6e4;border-radius:99px;border:2px solid #fff}',
    '.mwl__body::-webkit-scrollbar-button{display:none;width:0;height:0}',
    '.mwl__row{display:flex;align-items:center;gap:12px;padding:12px 0;border-bottom:1px solid #eef2f7;min-width:0}',
    '.mwl__row:last-child{border-bottom:0}',
    '.mwl__check{flex:none;width:20px;height:20px;min-width:20px;accent-color:#b42350;cursor:pointer}',
    '.mwl__check:disabled{cursor:not-allowed;opacity:.4}',
    '.mwl__thumb{flex:none;width:64px;height:64px;object-fit:contain;border-radius:8px;background:#f7fafd}',
    '.mwl__info{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:2px}',
    '.mwl__info a{color:inherit;text-decoration:none;font-weight:600;font-size:14px;line-height:1.35;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
    '.mwl__info a:hover{text-decoration:underline}',
    '.mwl__variant{font-size:12px;color:#6b7f96}',
    '.mwl__price{margin:0;font-size:14px;font-weight:600}',
    '.mwl__soldout{font-size:12px;color:#b42350;font-weight:600}',
    '.mwl__rm{flex:none;min-height:40px;padding:8px 10px;border:0;background:transparent;color:#6b7f96;font-size:13px;text-decoration:underline;cursor:pointer;border-radius:8px}',
    '.mwl__rm:hover{color:#b42350;background:#fff1f5}',
    '.mwl__foot{position:sticky;bottom:0;z-index:2;display:flex;align-items:center;gap:12px;flex-wrap:wrap;padding:14px 18px;border-top:1px solid #e6eef7;background:#fff}',
    '.mwl__all{display:flex;align-items:center;gap:8px;font-size:14px;cursor:pointer;user-select:none;min-height:40px}',
    '.mwl__all input{width:18px;height:18px;accent-color:#b42350;cursor:pointer}',
    '.mwl__actions{margin-inline-start:auto;display:flex;align-items:center;gap:8px}',
    '.mwl__add,.mwl__buy{min-height:46px;padding:12px 18px;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;white-space:nowrap}',
    '.mwl__add{border:1px solid #1b4f8a;background:#fff;color:#1b4f8a}',
    '.mwl__buy{border:0;background:#1b4f8a;color:#fff}',
    '.mwl__add[disabled],.mwl__buy[disabled]{border-color:#c3d2e2;background:#eef2f7;color:#9fb1c4;cursor:not-allowed}',
    '.mwl__buy[disabled]{background:#c3d2e2;color:#fff}',
    '.mwl__note{flex-basis:100%;margin:0;font-size:13px;color:#b42350}',
    '.mwl__empty{padding:28px 4px;text-align:center;color:#6b7f96}',
    '@media(max-width:560px){',
    '#meddey-wishlist{width:100vw;max-width:100vw;max-height:92dvh;border-radius:16px 16px 0 0;margin:auto auto 0}',
    '.mwl__thumb{width:52px;height:52px}',
    '.mwl__rm{padding:8px 4px}',
    '.mwl__actions{width:100%;margin-inline-start:0}',
    '.mwl__add,.mwl__buy{flex:1 1 0;min-width:0;padding:12px 10px;font-size:14px}',
    '}',
    /* --- saved-to-wishlist feedback --- */
    '@keyframes mwl-pop{0%{transform:scale(1)}35%{transform:scale(1.45)}65%{transform:scale(.86)}100%{transform:scale(1)}}',
    '.meddey-wishlist-toggle.is-wl-pop svg{animation:mwl-pop .45s ease}',
    '@keyframes mwl-bump{0%,100%{transform:scale(1)}40%{transform:scale(1.3)}}',
    '.is-wl-bump svg{animation:mwl-bump .45s ease}',
    '@keyframes mwl-ring{0%{transform:scale(.4);opacity:.6}100%{transform:scale(2.2);opacity:0}}',
    '.mwl-ring{position:fixed;z-index:99999;pointer-events:none;width:44px;height:44px;margin-left:-22px;margin-top:-22px;border-radius:50%;border:2px solid #b42350;animation:mwl-ring .55s ease-out forwards}',
    '.mwl-fly{position:fixed;z-index:100000;pointer-events:none;font-size:24px;line-height:1;color:#b42350;margin-left:-12px;margin-top:-12px;transition:transform .62s cubic-bezier(.35,-0.35,.3,1),opacity .62s ease}',
    '[data-open-meddey-wishlist]{position:relative}',
    /* The count sits on the heart icon, not on the whole link, so it never covers the "Wishlist" label */
    '.mwl-icon{position:relative;display:inline-flex;flex:none}',
    '.mwl-count{position:absolute;top:-7px;right:-6px;min-width:17px;height:17px;padding:0 4px;border-radius:99px;background:#b42350;color:#fff;font-size:11px;font-weight:700;line-height:17px;text-align:center;pointer-events:none;box-shadow:0 0 0 2px #fff;box-sizing:border-box}',
    '.mwl-count--inline{position:static;display:inline-block;margin-inline-start:6px;vertical-align:1px;box-shadow:none}',
    '.mwl-count.is-bumped{animation:mwl-bump .45s ease}',
    '.mwl-toast{position:fixed;z-index:100001;left:50%;bottom:24px;transform:translate(-50%,150%);display:flex;align-items:center;gap:10px;max-width:min(430px,calc(100vw - 24px));padding:12px 14px;border-radius:12px;background:#132132;color:#fff;box-shadow:0 14px 36px rgba(16,32,56,.34);opacity:0;pointer-events:none;transition:transform .4s cubic-bezier(.2,.9,.3,1.25),opacity .28s ease}',
    '.mwl-toast.is-in{transform:translate(-50%,0);opacity:1;pointer-events:auto}',
    '.mwl-toast__heart{flex:none;color:#ff6b9a;font-size:20px;line-height:1;animation:mwl-pop .55s ease}',
    '.mwl-toast__text{display:flex;flex-direction:column;min-width:0;font-size:13px;line-height:1.35}',
    '.mwl-toast__text span{opacity:.76;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
    '.mwl-toast__view{margin-inline-start:6px;flex:none;min-height:36px;padding:7px 13px;border:0;border-radius:8px;background:rgba(255,255,255,.16);color:#fff;font-size:13px;font-weight:600;cursor:pointer}',
    '.mwl-toast__view:hover{background:rgba(255,255,255,.26)}',
    '@media(prefers-reduced-motion:reduce){.meddey-wishlist-toggle.is-wl-pop svg,.is-wl-bump svg,.mwl-toast__heart{animation:none}.mwl-toast{transition:opacity .2s ease}}'
  ].join('');
  document.head.append(style);

  /* ---------- state sync ---------- */
  function sync() {
    const saved = read();
    document.querySelectorAll('[data-wishlist-handle]').forEach(button => {
      const active = saved.includes(button.dataset.wishlistHandle);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? t('saved', 'Saved to wishlist') : t('save', 'Add to wishlist')) + (button.dataset.wishlistTitle ? ': ' + button.dataset.wishlistTitle : ''));
      const label = button.querySelector('.meddey-wishlist-text');
      if (label) label.textContent = active ? t('saved', 'Saved to wishlist') : t('save', 'Add to wishlist');
    });
    document.querySelectorAll('[data-open-meddey-wishlist]').forEach(opener => {
      let badge = opener.querySelector('.mwl-count');
      if (!saved.length) { badge?.remove(); return; }
      if (!badge) {
        badge = node('span'); badge.className = 'mwl-count';
        const icon = opener.querySelector('svg');
        if (icon) {
          let holder = icon.parentElement.classList.contains('mwl-icon') ? icon.parentElement : null;
          if (!holder) { holder = node('span'); holder.className = 'mwl-icon'; icon.replaceWith(holder); holder.append(icon); }
          holder.append(badge);
        } else {
          badge.classList.add('mwl-count--inline');
          opener.append(badge);
        }
      }
      if (badge.textContent !== String(saved.length)) {
        badge.textContent = saved.length;
        badge.classList.remove('is-bumped');
        void badge.offsetWidth;
        badge.classList.add('is-bumped');
      }
    });
  }
  function save(handles) { localStorage.setItem(KEY, JSON.stringify(handles)); sync(); document.dispatchEvent(new CustomEvent('meddey:wishlist-changed', { detail: { count: handles.length } })); }

  /* ---------- add-to-wishlist feedback ---------- */
  function toast(title) {
    let el = document.querySelector('.mwl-toast');
    if (!el) { el = node('div'); el.className = 'mwl-toast'; el.setAttribute('role', 'status'); document.body.append(el); }
    const hide = () => el.classList.remove('is-in');
    const heart = node('span', '♥'); heart.className = 'mwl-toast__heart';
    const text = node('span'); text.className = 'mwl-toast__text';
    text.append(node('strong', t('saved', 'Saved to wishlist')));
    if (title) text.append(node('span', title));
    const view = node('button', t('view', 'View')); view.type = 'button'; view.className = 'mwl-toast__view';
    view.addEventListener('click', () => { hide(); open(); });
    el.replaceChildren(heart, text, view);
    requestAnimationFrame(() => el.classList.add('is-in'));
    clearTimeout(el.__timer);
    el.__timer = setTimeout(hide, 3400);
  }

  function celebrate(fromEl) {
    fromEl.classList.add('is-wl-pop');
    setTimeout(() => fromEl.classList.remove('is-wl-pop'), 500);
    toast(fromEl.dataset.wishlistTitle || '');
    if (reduced.matches) return;
    const a = fromEl.getBoundingClientRect();
    const cx = a.left + a.width / 2, cy = a.top + a.height / 2;

    const ring = node('span'); ring.className = 'mwl-ring';
    ring.style.left = cx + 'px'; ring.style.top = cy + 'px';
    document.body.append(ring);
    setTimeout(() => ring.remove(), 600);

    const target = [...document.querySelectorAll('[data-open-meddey-wishlist]')].find(el => el.offsetParent !== null);
    if (!target) return;
    const b = target.getBoundingClientRect();
    const ghost = node('span', '♥'); ghost.className = 'mwl-fly';
    ghost.style.left = cx + 'px'; ghost.style.top = cy + 'px';
    document.body.append(ghost);
    const dx = (b.left + b.width / 2) - cx, dy = (b.top + b.height / 2) - cy;
    requestAnimationFrame(() => { ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.3)'; ghost.style.opacity = '0'; });
    setTimeout(() => ghost.remove(), 680);
    target.classList.add('is-wl-bump');
    setTimeout(() => target.classList.remove('is-wl-bump'), 520);
  }

  /* ---------- dialog ---------- */
  function build() {
    dialog = document.createElement('dialog');
    dialog.id = 'meddey-wishlist';
    dialog.setAttribute('aria-labelledby', 'meddey-wishlist-title');

    const head = node('header'); head.className = 'mwl__head';
    const heading = node('h2', t('title', 'Your wishlist')); heading.id = 'meddey-wishlist-title';
    countChip = node('span'); countChip.className = 'mwl__chip'; heading.append(countChip);
    const close = node('button', '×'); close.type = 'button'; close.className = 'mwl__close';
    close.setAttribute('aria-label', t('close', 'Close'));
    close.addEventListener('click', () => dialog.close());
    head.append(heading, close);

    list = node('div'); list.className = 'mwl__body'; list.dataset.wishlistItems = '';
    list.setAttribute('data-lenis-prevent', '');   // let this panel scroll natively under Lenis

    foot = node('footer'); foot.className = 'mwl__foot';
    const allLabel = node('label'); allLabel.className = 'mwl__all';
    allBox = document.createElement('input'); allBox.type = 'checkbox';
    allLabel.append(allBox, node('span', t('select_all', 'Select all')));
    const actions = node('div'); actions.className = 'mwl__actions';
    addBtn = node('button'); addBtn.type = 'button'; addBtn.className = 'mwl__add'; addBtn.disabled = true;
    buyBtn = node('button'); buyBtn.type = 'button'; buyBtn.className = 'mwl__buy'; buyBtn.disabled = true;
    actions.append(addBtn, buyBtn);
    note = node('p'); note.className = 'mwl__note'; note.setAttribute('role', 'status');
    foot.append(allLabel, actions, note);

    allBox.addEventListener('change', () => {
      list.querySelectorAll('.mwl__check:not(:disabled)').forEach(c => { c.checked = allBox.checked; });
      refreshFooter();
    });
    list.addEventListener('change', e => { if (e.target.classList.contains('mwl__check')) refreshFooter(); });
    addBtn.addEventListener('click', () => addSelected(false));
    buyBtn.addEventListener('click', () => addSelected(true));

    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { generation++; previousFocus?.focus(); });

    dialog.append(head, list, foot);
    document.body.append(dialog);
  }

  function refreshFooter() {
    const boxes = [...list.querySelectorAll('.mwl__check:not(:disabled)')];
    const picked = boxes.filter(c => c.checked);
    addBtn.disabled = buyBtn.disabled = picked.length === 0;
    addBtn.textContent = picked.length
      ? t('add_selected', 'Add {{count}} to cart').replace('{{count}}', picked.length)
      : t('add_none', 'Add to cart');
    buyBtn.textContent = t('buy_now', 'Buy now');
    allBox.checked = boxes.length > 0 && picked.length === boxes.length;
    allBox.indeterminate = picked.length > 0 && picked.length < boxes.length;
    note.textContent = '';
  }

  async function addSelected(thenCheckout) {
    const picked = [...list.querySelectorAll('.mwl__check:checked')];
    if (!picked.length) return;
    const btn = thenCheckout ? buyBtn : addBtn;
    const originalAdd = addBtn.textContent, originalBuy = buyBtn.textContent;
    addBtn.disabled = buyBtn.disabled = true;
    btn.textContent = t('adding', 'Adding…'); note.textContent = '';
    try {
      const res = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: picked.map(c => ({ id: Number(c.dataset.variantId), quantity: 1 })) })
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.description || body.message || 'Add to cart failed');
      }
      if (thenCheckout) {
        // straight to the payment gateway (Zecpe), same hand-off the mini-cart uses
        dialog.close();
        if (typeof window.meddeyGoToCheckout === 'function') window.meddeyGoToCheckout(null);
        else window.location.href = root + 'checkout';
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
      dialog.close();
      const miniCart = document.getElementById('mini-cart');
      if (miniCart) { miniCart.open = true; miniCart.setAttribute('open', ''); }
    } catch (err) {
      addBtn.disabled = buyBtn.disabled = false;
      addBtn.textContent = originalAdd; buyBtn.textContent = originalBuy;
      note.textContent = err.message || t('add_failed', 'Could not add these to the cart. Please try again.');
    }
  }

  function open() {
    if (!dialog) build();
    previousFocus = document.activeElement;
    if (!dialog.open) dialog.showModal();
    render();
  }

  async function render() {
    const current = ++generation, handles = read();
    list.replaceChildren();
    countChip.textContent = handles.length || '';
    countChip.hidden = !handles.length;
    if (!handles.length) {
      const empty = node('p', t('empty', 'No saved products yet. Save a product using its heart button.'));
      empty.className = 'mwl__empty';
      list.append(empty); foot.hidden = true; return;
    }
    foot.hidden = false;

    const renderItem = async (handle) => {
      const row = node('article'); row.className = 'mwl__row';
      const check = document.createElement('input'); check.type = 'checkbox'; check.className = 'mwl__check'; check.disabled = true;
      const info = node('div'); info.className = 'mwl__info';
      info.append(node('span', t('loading', 'Loading saved product…')));
      const remove = node('button', t('remove', 'Remove')); remove.type = 'button'; remove.className = 'mwl__rm';
      remove.addEventListener('click', () => { try { save(read().filter(x => x !== handle)); render(); } catch { note.textContent = t('storage_error', 'Unable to update wishlist storage.'); } });
      row.append(check, info, remove); list.append(row);
      try {
        const product = await productData(handle);
        if (current !== generation) return;
        info.replaceChildren();
        const link = node('a', product.title); link.href = root + 'products/' + encodeURIComponent(handle);
        info.append(link);
        const variants = product.variants || [];
        const variant = variants.find(v => v.available) || variants[0];
        if (variant && variants.length > 1 && variant.title && variant.title !== 'Default Title') {
          const vn = node('span', variant.title); vn.className = 'mwl__variant'; info.append(vn);
        }
        if (variant && variant.available) {
          check.disabled = false;
          check.checked = true;                    // everything in stock is selected by default
          check.dataset.variantId = variant.id;
          check.setAttribute('aria-label', t('select', 'Select') + ' ' + product.title);
          const price = node('p', money(variant.price)); price.className = 'mwl__price'; info.append(price);
        } else {
          const so = node('span', t('sold_out', 'Sold out')); so.className = 'mwl__soldout'; info.append(so);
        }
        if (product.featured_image) {
          const image = node('img'); image.className = 'mwl__thumb'; image.src = product.featured_image;
          image.alt = product.title; image.width = 64; image.height = 64; image.loading = 'lazy';
          check.after(image);
        }
        remove.setAttribute('aria-label', t('remove', 'Remove') + ' ' + product.title);
      } catch {
        if (current !== generation) return;
        info.replaceChildren(node('span', t('unavailable', 'This saved product is unavailable right now. ')));
        const retry = node('button', t('retry', 'Try again')); retry.type = 'button'; retry.className = 'mwl__rm';
        retry.addEventListener('click', render); info.append(retry);
      }
    };
    for (let i = 0; i < handles.length; i += 4) {
      if (current !== generation) return;
      await Promise.all(handles.slice(i, i + 4).map(renderItem));
      refreshFooter();
    }
    refreshFooter();
  }

  /* ---------- events ---------- */
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-meddey-wishlist]');
    if (opener) { event.preventDefault(); open(); return; }
    const button = event.target.closest('[data-wishlist-handle]'); if (!button) return;
    event.preventDefault();
    const handle = button.dataset.wishlistHandle; if (!handle) return;
    try {
      const saved = read(), adding = !saved.includes(handle);
      save(adding ? [...saved, handle] : saved.filter(x => x !== handle));
      if (adding) celebrate(button);
      if (dialog?.open) render();
    } catch {
      let status = button.parentElement.querySelector('[role=alert]');
      if (!status) { status = node('p'); status.setAttribute('role', 'alert'); button.parentElement.append(status); }
      status.textContent = t('storage_error', 'Wishlist storage is unavailable. Please enable browser storage and try again.');
    }
  });
  window.addEventListener('storage', event => { if (event.key === KEY) { sync(); if (dialog?.open) render(); } });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('meddey:products-loaded', sync);
  document.addEventListener('variant:changed', () => requestAnimationFrame(sync));
  sync();
})();
